const AB_TEST_PROBABILITY = 0.5;
const LOCAL_STORAGE_KEY = 'standardCompanyProfileQuestionExperiment';

const getIsUserInExperiment = () => {
  const item = localStorage.getItem(LOCAL_STORAGE_KEY);

  if (item) {
    return Boolean(JSON.parse(item));
  }

  const value = Math.random() < AB_TEST_PROBABILITY;

  localStorage.setItem(LOCAL_STORAGE_KEY, value.toString());

  return value;
};

const standardCompanyProfileQuestionExperiment = {
  getIsUserInExperiment,
};

export default standardCompanyProfileQuestionExperiment;
